const updateAuthToken = (state, { payload: { token } }) => {
	state.token = token;
};

export default updateAuthToken;
